import React from 'react';

import { useLinkTo, useMount } from '../../../../hooks';
import NotificationBanner from '../NotificationBanner';
import analytics from '../../../../modules/analytics';
import { MegaPhoneIcon } from '../../../ui/Icons';
import withStore from '../../../withStore';
import stateManager from '../../../../modules/user/stateManager';

const TRACKING_PREFIX = 'pro_notifications_marketing_tab_';
const MARKETING_HUB_NOTIFICATION_ACTION = 'pro-notification-marketing-hub-clicked';

export type MarketingHubNotificationProps = {
  providerId: number;
  notification: object;
};
const MarketingHubNotification: React.FC<MarketingHubNotificationProps> = ({
  providerId,
  notification,
}) => {
  const linkTo = useLinkTo();
  const buttonProps = {
    text: 'Get Marketing Advice',
    size: 'small',
    clickTracking: {
      name: `${TRACKING_PREFIX}click`,
      params: {
        providerId,
      },
    },
    onClick: () => {
      stateManager.addAction(MARKETING_HUB_NOTIFICATION_ACTION, true)
        .then(() => linkTo('provider.marketing_hub', {
          providerId,
          source: 'notification',
        }));
    },
  };
  useMount(() => {
    analytics.track(`${TRACKING_PREFIX}view`, {
      providerId,
    });
  });
  return (
    <NotificationBanner
      icon={MegaPhoneIcon}
      iconColor="#F50990"
      notification={notification}
      iconSize={40}
      buttonProps={buttonProps}
      highlightedText="Introducing StyleSeat Marketing."
      text="Advice for your business that makes you more money."
    />
  );
};

export const shouldShowMarketingHubNotification = async (profileCreationTime: string) => {
  const launchDate = new Date('17 Sept 2021 00:00:00 PST');
  const isEligibleBasedOnDate = (
    new Date(profileCreationTime) < launchDate
    && new Date().getDate() < (new Date().setDate(launchDate.getDate() + 30))
  );
  if (!isEligibleBasedOnDate) return false;

  const seenNotification = await stateManager.getActionValue(MARKETING_HUB_NOTIFICATION_ACTION);
  return !seenNotification;
};

export const createMarketingHubNotification = (providerId: number) => ({
  creation_time: new Date(),
  persistent: true,
  providerId,
  type: 'marketing_hub_announcement',
  uuid: 'marketing-hub-announcement-notification',
});

export default withStore(MarketingHubNotification);
